var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 16.5H4.125V5.25C4.125 4.8375 4.4625 4.5 4.875 4.5H13.875C14.2875 4.5 14.625 4.8375 14.625 5.25V7.875H16.875V3.75C16.875 2.5125 15.8625 1.5 14.625 1.5H4.125C2.8875 1.5 1.875 2.5125 1.875 3.75V17.25V20.25C1.875 21.4875 2.8875 22.5 4.125 22.5H14.625C15.8625 22.5 16.875 21.4875 16.875 20.25V17.25C16.875 16.8375 16.5375 16.5 16.125 16.5ZM10.875 20.25H7.875V18.75H10.875V20.25ZM22.5 14.25V15.75H18C18 14.5125 16.9875 13.5 15.75 13.5C14.5125 13.5 13.5 14.5125 13.5 15.75H9V14.25C9 13.8375 9.3375 13.5 9.75 13.5H11.2125L10.1625 12.45C9.8625 12.15 9.8625 11.7 10.1625 11.4L11.7375 9.825C12.0375 9.525 12.4875 9.525 12.7875 9.825L13.8375 10.875V9.375C13.8375 8.9625 14.175 8.625 14.5875 8.625H16.8375C17.25 8.625 17.5875 8.9625 17.5875 9.375V10.8375L18.6375 9.7875C18.9375 9.4875 19.3875 9.4875 19.6875 9.7875L21.2625 11.3625C21.5625 11.6625 21.5625 12.1125 21.2625 12.4125L20.2875 13.5H21.75C22.1625 13.5 22.5 13.8375 22.5 14.25Z",
    fill: "#B3A5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobAppDevelopment);
export default __webpack_public_path__ + "static/media/mob-app-development.f414a894cd3fd1f147660c0bd6123dd8.svg";
export { ForwardRef as ReactComponent };